<template>
  <div class="price-inquiry"  v-loading="loading">
    <div class="left-dir position-relative md-el-aside" v-resize-width>
      <tree-list
        v-for="item in TreeArr"
        :key="item.categoryType"
        :ref="item.categoryType"
        :categoryType="item.categoryType"
        @dirChanged="(data, node) => treeDirChange(data, node, item.categoryType)"
        :defaultExpandedKeys="expandedType == item.categoryType && expandedTreeId ? [expandedTreeId] : []"
        :defaultNode="item.defaultNode"
      ></tree-list>
      
      <div style="flex: 1;cursor: auto;"></div>
    </div>

    <div v-if="curDirType === '1'" class="content">
         <!-- <el-empty description="暂无数据"></el-empty> -->
        <div class="data-title">
              <div>
                询价列表
                 <span style="margin-left:30px;">状态：</span>
                <el-select v-model="status" placeholder="请选择" @change="getInquiryList">
                  <el-option
                    v-for="item in statusList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
                </div>
            
              <el-button type="primary" style="margin-right:100px;" @click="addQuiry">新增询价</el-button>
        </div>
         <el-table
          :data="dataList"
          :row-class-name="tableRowClassName"
          :header-cell-style="{ background: '#F5F5F5' }"
          :default-sort = "{prop: 'createDate', order: 'descending'}"
          size="mini"
          empty-text="暂无数据"
          :height="tabHeight"
          style="width: 100%"
        >
            <el-table-column
            label="产品图片"
            align="center"
            width="120"
            >
            <template slot-scope="scope">
              <div style="position: relative">
              <template v-if="scope.row.inquiryImages && scope.row.inquiryImages">
                  <el-image 
                    style="width: 56px;"
                    :src="returnImgUrl(scope.row.inquiryImages)" 
                    :preview-src-list="[returnImgUrl(scope.row.inquiryImages)]">
                  </el-image>
                <!-- <img width="56px" :src="returnImgUrl(scope.row.inquiryImages)" /> -->
              </template>
              <div class="edit-view">
              <i class="drag-edit" title="可拖拽放置指定的目录中"><svg-drag :width="18" :height="18" fill="#ffffff"></svg-drag></i>
              </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            label="询价标题"
          >
            <template slot-scope="scope">
              <div  class="ellipsis-text" :title="scope.row.inquiryTitle">{{scope.row.inquiryTitle}}</div>
            </template>
          </el-table-column>
          <el-table-column
            label="产品名称及型号"
            >
             <template slot-scope="scope">
              <div :title="scope.row.productNameModel" class="ellipsis-text">{{scope.row.productNameModel}}</div>
            </template>
          </el-table-column>
          <el-table-column label="规格与技术参数">
            <template slot-scope="scope">
              <div :title="scope.row.specificationsParameters" class="ellipsis-text">{{scope.row.specificationsParameters}}</div>
            </template>
          </el-table-column>
          <el-table-column label="状态" prop="CompName"  width="100" align="center">
            <template slot-scope="scope">
              <el-tag type="success" size="medium" style="font-size:14px;" v-if="scope.row.status== 2">{{ statusText[scope.row.status+'']}}</el-tag>
              <el-tag type="warning" size="medium" style="font-size:14px;"  v-if="scope.row.status== 1">{{ statusText[scope.row.status+'']}}</el-tag>
              <el-tag type="info" size="medium" style="font-size:14px;"  v-if="scope.row.status== 0 || !scope.row.status">{{ statusText[scope.row.status+'']}}</el-tag>
              <!-- <span style="font-size: 14px;" :class="statusStyle(scope.row.status)">{{ statusText[scope.row.status+'']}}</span> -->
            </template>
          </el-table-column>
            <el-table-column
            label="报价结果"
            align="center"
            width="150"
            >
             <template slot-scope="scope">
              <div v-if="scope.row.quoteCount > 0">报价数量: <span style="color:#e6a23c;font-size:16px;">{{scope.row.quoteCount}}</span></div>
              <div v-if="scope.row.quoteCount <1">未收到报价</div>
            </template>
          </el-table-column>
           <el-table-column
           prop="createDate"
            label="询价时间"
            sortable
            align="center"
            width="160"
            >
             <template slot-scope="scope">
              <div>{{scope.row.createDate}}</div>
            </template>
          </el-table-column>
          <el-table-column
            label="操作"
            align="center"
            width="200"
          >
            <template slot-scope="scope">
              <el-button v-if="scope.row.status == '0'" type="text" size="small" @click.prevent="editQuiry(scope.row)">修改</el-button>
               <el-button type="text" size="small" @click.prevent="detailQuiry(scope.row)">询价详情</el-button>
              <el-button type="text" size="small" @click.prevent="goQuotationList(scope.row)">报价信息</el-button>
            </template>
          </el-table-column>
        </el-table>
    </div>

    <!-- 成交供应商 -->
    <div v-if="curDirType === '2'" class="content">
         <!-- <el-empty description="暂无数据"></el-empty> -->
        <div class="data-title">
              <div>供应商列表：</div>
              <!-- <el-button type="primary" style="margin-right:100px;" @click="addQuiry">新增询价</el-button> -->
        </div>
         <el-table
          :data="dataList"
          :row-class-name="tableRowClassName"
          :header-cell-style="{ background: '#F5F5F5' }"
          size="mini"
          empty-text="暂无数据"
          :height="tabHeight"
          style="width: 100%">
            <el-table-column
            label="公司LOGO"
            align="center"
            width="200px"
            >
            <template slot-scope="scope">
              <template v-if="scope.row.companyInfo && scope.row.companyInfo.compLogo">
                <img  width="40px" :src="returnImgUrl(scope.row?.companyInfo?.compLogo||'')" />
              </template>
              <div class="edit-view">
              <i class="drag-edit" title="可拖拽放置指定的目录中"><svg-drag :width="18" :height="18" fill="#ffffff"></svg-drag></i>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            label="公司名称"
            align="center"
          >
            <template slot-scope="scope">
              <div>{{(scope.row.companyInfo && scope.row.companyInfo.compName) || ''}}</div>
            </template>
          </el-table-column>
          <el-table-column
            label="操作"
            align="center">
            <template slot-scope="scope">
              <!-- <el-button v-if="scope.row.status == '0'" type="text" size="small" @click.prevent="editQuiry(scope.row)">修改</el-button> -->
               <!-- <el-button  type="text" size="small" @click.prevent="detailQuiry(scope.row)">询价详情</el-button> -->
              <el-button type="text" size="small" @click.prevent="goQuotationList(scope.row)">报价信息</el-button>
            </template>
          </el-table-column>
        </el-table>
    </div>
  </div>
</template>

<script>
import {MessageBox,Message} from 'element-ui'
import {WinForm,CheckLibs,Category} from '@digital-supply-chain/module'
import {UtilService, DomainService} from '@/libs'
import {UserService,OpenService, ApiService, PriceQuiryService, DragService} from '@/service'

import {AutoCreateLectoDir, TreeArrData} from './defaultData'

import TreeList from '@/components/dir-tree/tree-list.vue';
import SvgDrag from '@/components/svg/drag.vue';

const isClient = CheckLibs.isClient();
// 默认展开供应链还是零配件
const expanded = isClient ? WinForm.storge.get(`$inquiry_expanded_dir_${UserService.userID()}`) : sessionStorage.getItem(`$inquiry_expanded_dir_${UserService.userID()}`);
let expandSplit = [];
try {
  expandSplit = expanded ? expanded.split(',') : [];
} catch (error) {}
const [expandedType = 'PriceQuiry', expandedTreeId = 'list_0'] = expandSplit;

export default {
  data() {
    return {
      loading: false,
      domain:  `${ApiService.ImageHost}`,
      domain2:  `${ApiService.OssLook}`,

      expandedType,
      expandedTreeId,
      TreeArr: [],
      recommdTip: false,
      isClient,
      curDirName: '',
      curDirID: '',
      curDirType: '1',
      status: '-1',
      statusText:{
        '0':'暂存',
        '1': '发布',
        '2': '已成交'
      },
      dataList: [], // 询价列表
      tabHeight: document.body.clientHeight - 20 - 43,
      statusList: [
        {value: '-1',label: '全部'},
        {value: '0',label: '暂存'},
        {value: '1',label: '发布'},
        {value: '2',label: '已成交'},
      ]
    }
  },
  components: { TreeList, SvgDrag },
  mounted() {
    // 设置默认的零配件目录
    AutoCreateLectoDir();
    
    this.getTreeArr();
    // this.curDirID = this.$route.query.dirID||'';
    // this. curDirName = this.$route.query.dirName||'';
    // 其他页面跳转过来需要判断哪一个打文件树开
    this.curDirType = this.$route.query.dirType;
    if(this.curDirType) {
      const cateStr = this.curDirType == '1'? 'PriceQuiry':'CompleteSupplier'
      this.expandedType = cateStr;
      this.setDefaultCurrent(cateStr, 'list_0')
    }
   
    // 进页面请求一次
    this.getData()
    window.onresize = () => {
      this.tabHeight = document.body.clientHeight - 20 - 43
    }
  },
  methods: {
    // 增加图片渲染url
    returnImgUrl(obsUrl) {

      if(!obsUrl) return ''
      const newwUrl =obsUrl;
      const strArr = ['prod/', 'series/', 'logo/', 'mx/', 'yb/', 'sw/', 'wx/', 'images/'];
      if(typeof newwUrl === 'number') {
        return ''
      }
      const containsAny = strArr.some(str => (newwUrl.key|| newwUrl || '').includes(str));
      if(containsAny) {
        return `${this.domain}/${newwUrl.key || newwUrl}_300x300.jpg`;
      }else {
        return  `${this.domain2}/${newwUrl.key}?x-oss-process=image/resize,w_300`
      }
    },
    // 表格自定义
    tableRowClassName({row, rowIndex}) {
      // 根据行数据判断条件
      if (row.status == '2') {
        return 'succees-row';
      }
      if(row.status == '1') {
        return 'warning-row'
      }
      return '';
    },
    // 状态渲染
    statusStyle(status) {
      switch(status) {
        case 1:
        case '1':
          return 'warning-text';
        case 2: 
        case '2':
          return 'success-text';
        default:
          return ''
      }
    },

    async getTreeArr() {
    //   const res = await UserService.isOrderMember();
      this.TreeArr = TreeArrData();
      this.$nextTick(() => {
        this.getDefaultCurrent();
      })
    },

    // 默认打开哪个顶级目录
    getDefaultCurrent() {
      try {
        this.$refs[this.expandedType][0].select(this.expandedTreeId);
      } catch (error) {}
    },

    // 设置下次用户进来后默认展开供应商还是零配件
    setDefaultCurrent(categoryType, treeId) {
      if (!isClient) {
        sessionStorage.setItem(`$inquiry_expanded_dir_${UserService.userID()}`, `${categoryType},${treeId}`);
        return;
      }
      WinForm.storge.set(`$inquiry_expanded_dir_${UserService.userID()}`, `${categoryType},${treeId}`);
    },

    treeDirChange(data, node, categoryType) {
      // console.log(data, node, categoryType, 'data, node, categoryType')
      // 设置其他树所有不选中
      this.TreeArr.filter(item => item.categoryType != categoryType).forEach(item => {
        this.$refs[item.categoryType][0].setCurrentNull();
      })
      this.dirChanged(data, node, categoryType);
    },
    dirChanged(data, node, categoryType) {
      if (!categoryType) return;
      this.curDirName = data.DirID ? data.DirName: this.curDirName;
      this.curDirID =  data.DirID || '';
      this.curDirType = categoryType ==='PriceQuiry' ? '1':'2';
      // === 当前节点的所有父节点数组 ===
      let parents=[node.data];
      let obj = node;
      while (obj.parent.data && obj.parent.data.DirName){
          parents.push(obj.parent.data);
          obj = obj.parent;
      }
      this.setDefaultCurrent(categoryType, parents[0].TreeID);
      // 获取列表数据
        this.getData()
    },

     initDrag() {
      const curData = [...this.dataList];
      this.$nextTick(() => {
        DragService.dragToTree({
          table: document.getElementsByClassName('content')[0],
          wrapper: 'tbody',
          handle: ".drag-edit",
          delay: 1,
          datas: curData,
          // filter: '.comp-list2',
          primaryKey: this.curDirType == '1'? "id": "companyInfo",
          secondKey: this.curDirType == '1' ? '':'compId', // 数据比较深，增加层级
          category: this.curDirType == '1'? 21500 :31720,
          callback: this.dragCallback,
          dirCategory: this.curDirType == '1'? Category.PriceQuiry : Category.CompleteSupplier,  // 当前目录
          operateAreaId: this.curDirType == '1'? [Category.PriceQuiry] :[Category.CompleteSupplier], // 拖拽的范围
        })
      })
    },
    dragCallback(args) {

      args.row.index && (this.dataList[args.row.index].Exist = true)
      this.dragDataCallback(args.treeId, args.treeDirCategoryId, this.curDirID, args.dirCategoryId, args.copy);
      // 获取列表数据
      this.getData();
    },

    // 获取页面数据
    getData() {
      if(this.curDirType == '1') {
        this.getInquiryList();
      }
      if(this.curDirType == '2') {
        this.getInquirycompanyListList();
      }
    },

    // 获取询价列表数据
    async getInquiryList() {
      this.loading = true;
      this.dataList = [];
      const params = {dirId: this.curDirID, page:1, perPage:1000, type: this.curDirType, status: this.status}
      try{
        const res = await PriceQuiryService.getInquiryList(params);
        this.loading = false;
        if(res.data) {
          
            res.data.list.forEach(item => {
            item.DirID = this.curDirID;
            item.Exist = true;
          });
        
          this.dataList = res.data.list || [];
          // 初始化推拽
          this.initDrag()
        }
      }catch(err) {
        this.loading = false;
      }
      
      
    },
    // 获供应商价列表数据
    async getInquirycompanyListList() {
      this.loading = true;
      this.dataList = [];
      const params = {dirId: this.curDirID, page:1, perPage:1000}
      try{
        const res = await PriceQuiryService.getInquirycompanyListList(params);
        this.loading = false;
        if(res.data) {
            res.data.list.forEach(item => {
            item.DirID = this.curDirID;
            item.Exist = true;
          });
        
          this.dataList = res.data.list || [];
          // 初始化推拽
          this.initDrag()
        }
      }catch(err) {
         this.loading = false;
      }
      
      
    },
    // 新增询价
    addQuiry() {
      this.$router.push({
        path: '/priceInquiry/edit',
        query: {
          dirType: this.curDirType
        }
      });
    },
    // 修改询价
    editQuiry(row) {
      this.$router.push({
        path: '/priceInquiry/edit', 
        query: { 
          id: row.id,
          dirType: this.curDirType
        }
      });
    },
    // 询价详情
    detailQuiry(row) {
      this.$router.push({
        path: '/priceInquiry/detail', 
        query: { 
          id: row.id || row.inquiryId,
          type: 'detail',
          dirType: this.curDirType
        }
      });
    },
  // 报价列表
    goQuotationList(row) {
      this.$router.push({
        path: '/quotation/list', 
        query: { 
          id: row.id || row.quoteId,
          inquiryTitle: row.inquiryTitle,
          quoteTitle: row.quoteTitle || '',
          compName: row?.companyInfo?.compName || '',
          compId: row?.companyInfo?.compId || '',
          dirType: this.curDirType
        }
      });
    },

   // 重新计算树DataCount
    dragDataCallback(toId, toDirCategoryId, fromId, fromDirCategoryId, copy = false) {
      // 原始目录的count计算
      let orginData = { toId, fromId };
      const toCategoryType = this.TreeArr.find(item => item.categoryId == toDirCategoryId).categoryType;
      const fromCategoryType = this.TreeArr.find(item => item.categoryId == fromDirCategoryId).categoryType;
      if (copy) {
        delete orginData.fromId;
        this.$refs[toCategoryType][0].dragDataCallback({ toId })
      }
      if (orginData.fromId == 0) {
        this.$refs[toCategoryType][0].dragDataCallback(orginData)
      } else {
        this.$refs[fromCategoryType][0].dragDataCallback(orginData)
      }
    },

    
  }
}
</script>

<style lang="less" scoped>
.data-title {
  display:flex;
  align-items:center;
  justify-content: space-between;
  padding:10px;
  box-shadow:0px 2px #eee;
  font-size: 14px;
  font-weight: 600;
  color: #606266;
}
.content ::v-deep .el-table {
  font-size: 14px;
}
.ellipsis-text {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  text-overflow: ellipsis;
}

.left-dir{
  height: calc(100vh - 20px);
  overflow-y: auto;
  border-right: 6px solid #F2F2F2;
  max-width: 500px;
  min-width: 230px;
  cursor: ew-resize;
  display: flex;
  flex-direction: column;
  /deep/ .tree-span[data-id = "0"] {
    font-weight: bold;
    color: #606266;
  }
  /deep/ .tree-span[data-id = "-1"] {
    font-weight: bold;
    color: #606266;
  }
}
.header {
  display: flex;
  position: relative;
  .item-close {
    font-size: 30px;
    color: red;
  }
  .close-box {
    cursor: pointer;
    position: absolute;
    bottom: -50px;
    right: -10px;
  }
}

// .el-table  /deep/ .succees-row {
//   background-color: #f0f9eb; 
// }
.el-table  /deep/ .success-text {
  color: #67c23a;
}
// .el-table  /deep/ .warning-row {
//   background: #faecd8;
// }
.el-table  /deep/ .warning-text {
  color:#e6a23c;
}
.el-table  /deep/ .el-table__body tr.hover-row>td.el-table__cell {
  background-color: #e6f3f9;
  // background-color: #ff0;

}
.content {
    flex: 1;
    overflow: auto;
    // overflow-x: hidden;
    // height: calc(100vh - 20px);
    // overflow-y: auto;
  .footer {
    padding: 20px;
    text-align: right;
  }
::v-deep .el-table__body-wrapper {
    overflow: auto;
  }
}

.form-content {
  flex: 1;
  height: calc(100vh - 60px);
    overflow-y: auto;
}



.price-inquiry{
  display: flex;
  flex-direction: row;
  flex: 1;
  background: #ffffff;
  box-shadow: 0px 6px 20px 0px rgba(0, 0, 0, 0.1);
  /deep/ .el-divider--horizontal{
    margin: 0;
  }

  .edit-view{
    position: absolute;
    top: 50%;
    transform: translateY(-50%); 
    // bottom: 0;
    background: rgba(0, 0, 0, 0.7);
    display: flex;
    opacity: 0;
    // transform: translateY(26px);
    transition: all 0.4s;
    i{
      width: 26px;
      height: 26px;
      color: #fff;
      font-size: 18px;
      cursor: pointer;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .drag-edit{
      cursor: move;
    }
  }
  
  /deep/ .el-table__row:hover .edit-view{
    opacity: 1;
    // transform: translateY(0px);
  }

}

</style>
